<template>
    <div v-bind:class="[ 'select-col', 'component-' + box.component]">
        <div class="top-step-name basic-border basic-color">{{ box.title }}
        </div>
        <!-- SEARCHBOX -->

        <!-- FILTERBOXES -->
        <div class="designer-detailbox-description">
            <p><span id="detail-description">{{{ box.todo }}}</span></p>
        </div>

        <div class="nav-btn-box">
            <button @click="yesAction" type="button" class="prev-btn basic-bg">{{ translations['Yes'] }}</button>
            <button @click="noAction" class="next-btn basic-bg" type='button'>{{ translations['No'] }}</button>
        </div>
    </div>
</template>
<script>
export default {
  name: 'Contrastjumper',
  props: [ 'fabrics', 'items', 'box', 'filtertext', 'baseurl', 'personal', 'isactive', 'translations' ],
  data: function () {
    return {
      scrolling: false
    }
  },
  methods: {
    yesAction: function (event) {
      this.$dispatch('jumpTo', 'last')
    },
    noAction: function (event) {
      this.$dispatch('jumpTo', 'contrast')
    }
  },
  ready: function () {
    this.$dispatch('runDesignJQuery')
  }
}

</script>



// WEBPACK FOOTER //
// Contrastjumper.vue?a4dd82d2